import ___default from "lodash";
import { compareIgnoreCase, containsIgnoreCase } from "@ane/core/lib/utils/CommonStringUtils";
import "../../../../utils/flight.constants.js";
import { BING_EXPANDED_FEATURE_LINK } from "@ane/exp-data/lib/routes/FlightRoute.utils";
const buildCompositionInfo = (workspaceId, managementGroup, compositionResult) => {
  const isFeatureComp = isFeatureComposition(compositionResult);
  const rotatingParentFlights = isFeatureComp ? getRotatingParentFlights(compositionResult) : [];
  const workingCompositions = isFeatureComp ? getWorkingCompositions(compositionResult, workspaceId, managementGroup) : [];
  return {
    isFeatureComposition: isFeatureComp,
    name: compositionResult.SelectedFlight,
    compositionGraph: compositionResult,
    rotatingParentFlights,
    workingCompositions,
    managementGroup
  };
};
const isFeatureComposition = (compositionResult) => {
  return !!compositionResult.Nodes && ___default.some(compositionResult.Nodes, (node) => !compareIgnoreCase(node.FlightName, compositionResult.SelectedFlight));
};
const getRotatingParentFlights = (composition) => {
  var flightName = composition.SelectedFlight;
  const runningFlights = ___default.filter(composition.Nodes, (node) => {
    return containsIgnoreCase(
      (node.CompositionChildren || []).map((n) => n.FlightName),
      flightName
    ) && node.IsRunning;
  });
  return ___default.map(runningFlights, (flight) => flight.FlightName);
};
const getWorkingCompositions = (composition, workspaceId, managementGroup) => {
  var _a;
  const flight = ___default.find(composition.Nodes, (node) => compareIgnoreCase(node.FlightName, composition.SelectedFlight));
  if (!flight || !((_a = flight.CompositionChildren) == null ? void 0 : _a.length)) {
    return [];
  }
  const childrenFlightNames = ___default.map(flight.CompositionChildren, (n) => n.FlightName);
  const matchingCompositions = ___default.filter(composition.Nodes, (n) => containsIgnoreCase(childrenFlightNames, n.FlightName));
  return ___default.map(matchingCompositions, (n) => {
    var _a2, _b, _c;
    return {
      name: n.FlightName,
      isRunning: n.IsRunning,
      numOfParents: n.NumberOfParents,
      numOfChidren: ((_a2 = n.CompositionChildren) == null ? void 0 : _a2.length) || 0,
      isolationGroups: n.IsolationGroups || [],
      forceAssignOnNumberline: (_c = (_b = ___default.find(flight.CompositionChildren, (f) => compareIgnoreCase(f.FlightName, n.FlightName))) == null ? void 0 : _b.ForceAssignOnNumberline) != null ? _c : false,
      workspaceId,
      managementGroup
    };
  });
};
const getExpandedLivesiteLink = (composition) => {
  var _a;
  const expandedFlights = [];
  const nodeDict = ___default.keyBy(composition.compositionGraph.Nodes, (n) => n.FlightName);
  const descendants = [composition.compositionGraph.SelectedFlight];
  const visited = {};
  while (descendants.length > 0) {
    const flightName = descendants.shift();
    if (flightName) {
      expandedFlights.push(flightName);
      ___default.forEach((_a = nodeDict[flightName]) == null ? void 0 : _a.CompositionChildren, (c) => {
        if (!visited[c.FlightName]) {
          visited[c.FlightName] = true;
          descendants.push(c.FlightName);
        }
      });
    }
  }
  return `${BING_EXPANDED_FEATURE_LINK}${expandedFlights == null ? void 0 : expandedFlights.join(",")}`;
};
export {
  buildCompositionInfo,
  getExpandedLivesiteLink,
  getRotatingParentFlights,
  getWorkingCompositions,
  isFeatureComposition
};
//# sourceMappingURL=Composition.utils.js.map
